import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";


//Assets
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/store";

//actions
import { addAssetAddress, closeAssetInput } from "../../redux/walletReducer";
import ChainSelectDropdown from "./Dropdown";
import { AddButton, InputEl, WalletInputContainer, WalletInputWrapper } from "./style";

function AssetWalletInput() {
  const [assetAddress, setassetAddress] = useState<string>("");
  const [assetChain, setAssetChain] = useState<string>("");
  const dispatch = useDispatch();
  let wallet = useSelector((state: RootState) => state.walletState);

  const navigate = useNavigate();

  useEffect(() => {
    if (wallet.assetAddress) {
      setAssetChain(wallet.assetChain);
      setassetAddress(wallet.assetAddress);
    }
  }, []);

  if (!wallet.assetInputToggle) {
    return <></>;
  }

  return (
    <WalletInputContainer
      id="wc_bg"
      onClick={(e) => {
        if ((e.target as any).id === "wc_bg") {
          dispatch(closeAssetInput());
        }
      }}
    >
      <WalletInputWrapper>
        <h1 className="promptText"> Enter the Wallet Address Your Assets Are In</h1>
        <p className="promptDescription">
          You do NOT need connect this wallet to our site to create a Proxy
          Token. This step only loads public information on-chain.
        </p>
        <ChainSelectDropdown
          assetChain={assetChain}
          setAssetChain={setAssetChain}
        />
        <InputEl
          onChange={(e) => {
            setassetAddress(e.target.value);
          }}
          value={assetAddress}
          type="text"
          placeholder="Enter wallet address"
        />
        <AddButton
          onClick={() => {
            if (isEthAddress(assetAddress) && assetChain !== "") {
              dispatch(addAssetAddress({ assetAddress, assetChain }));
              dispatch(closeAssetInput());
              navigate(`/`);
            } else {
              alert("Invalid Address");
            }
          }}
        >
          Add Asset Wallet
        </AddButton>
      </WalletInputWrapper>
    </WalletInputContainer>
  );
}

function isEthAddress(address: string): boolean {
  // Check if the address matches the Ethereum address format
  if (!/^(0x)?[0-9a-f]{40}$/i.test(address)) {
    return false;
  }
  return true;
}

export default AssetWalletInput;
